export const REMINDER_TEXT_PLACEHOLDER = 'Order reminder text goes here'

export const REMINDER_TEXT_REQUIRED_WARNING = 'Add the reminder text before saving.'

// Reminders created before the editor required text were saved with this body.
const LEGACY_PLACEHOLDER_BODY = 'Reminder text goes here.'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

export const hasReminderText = text => typeof text === 'string' && text.trim().length > 0

export const editableReminderText = body => (!body || body.trim() === LEGACY_PLACEHOLDER_BODY ? '' : body)

export const defaultReminderDate = (now = new Date()) => new Date(now.getTime() + ONE_DAY_MS)

export const reminderAutomationAttributes = ({ id, templateId, datetime, body, attachVcard, images }) => ({
  ...(id ? { id } : {}),
  automation_scheduler_attributes: { datetime },
  message_template_attributes: {
    ...(templateId ? { id: templateId } : {}),
    body,
    attach_vcard: attachVcard,
    attachments_attributes: attachVcard ? [] : images
  }
})
